import { type ReactNode, useState } from 'react';
import { useGT } from 'gt-react';
import { CaretDownIcon, CaretRightIcon } from '@phosphor-icons/react';
import { DetailHeaderSlotContext } from './detailHeaderSlot';

interface DetailSectionProps {
  collapsed: boolean;
  onToggle: () => void;
  children: ReactNode;
}

/**
 * The Detail panel's content: one 28px bar holding the fold chevron and the
 * open cart's header (portaled in by the board), then the body.
 */
export function DetailSection({
  collapsed,
  onToggle,
  children,
}: DetailSectionProps) {
  const gt = useGT();
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  const Chevron = collapsed ? CaretRightIcon : CaretDownIcon;
  return (
    <>
      <div className="flex h-7 shrink-0 items-center gap-2 border-b border-border bg-background px-2 text-xs">
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={!collapsed}
          aria-controls="buyer-board-detail"
          aria-label={gt('Toggle detail', {
            context: 'buying board detail fold button',
          })}
          className="flex shrink-0 items-center"
        >
          <Chevron aria-hidden className="h-3 w-3" />
        </button>
        <div ref={setSlot} className="min-w-0 flex-1" />
      </div>
      <div id="buyer-board-detail" className="flex min-h-0 flex-1 flex-col">
        <DetailHeaderSlotContext.Provider value={slot}>
          {children}
        </DetailHeaderSlotContext.Provider>
      </div>
    </>
  );
}
